import React from 'react'

/**
 * Defines all columns for @FormsAndTemplatesV2 component's table.
 */
export const COLUMNS = [
  {
    Header: 'Form Name',
    accessor: 'name',
  },
  // {
  //   Header: 'Centers',
  //   accessor: (row: any, index: number) => row?.centers?.join(","),
  //   id: 'centers',
  // },
  // {
  //   Header: 'Write Rights',
  //   accessor: (row: any, index: number) => row?.writeRights?.join(","),
  //   id: 'writeRights',
  // },
  // {
  //   Header: 'Read Rights',
  //   accessor: (row: any, index: number) => row?.readRights?.join(","),
  //   id: 'readRights',
  // },
  // {
  //   Header: 'Service IDs',
  //   accessor: (row: any, index: number) => row?.servicesIds?.join(","),
  //   id: 'servicesIds',
  // },
  {
    Header: "",
    accessor: "edit",
    Cell: ({ cell: { } }) => (
      <img
        className="eye-icon"
        src={'assets/images/CRedit.svg'}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
  {
    Header: "",
    accessor: "Delete",
    Cell: ({ cell: { } }) => (
      <img
        className="eye-icon"
        src={"assets/images/CRdelete.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
]
